import * as types from '../actions/types';

const INITIAL_STATE = {
  currentUser: {},
  tutorProfile: {},
  isVerified: '',
  isNew: '',
  cities: [],
  onProgress: '',
  completed: '',
  prevPath: '',
  error: {
    type: '',
    message: '',
  },
};

const authReducer = (state = INITIAL_STATE, { payload, type, error }) => {
  // store cities used in signup
  switch (type) {
    case types.SET_USER_DATA:
      return {
        ...state,
        currentUser: payload,
      };
    case types.GET_CITIES_REQUEST:
      return {
        ...state,
        onProgress: 'GET_CITIES',
      };

    case types.GET_CITIES_SUCCESS:
      return {
        ...state,
        cities: payload,
        onProgress: '',
      };

    case types.GET_CITIES_FAIL:
      return {
        ...state,
        onProgress: '',
        error: {
          type: 'GET_CITIES',
          message: error,
        },
      };
    case types.SET_VERIFY_PHONE_ERROR:
      return {
        ...state,
        onProgress: '',
        completed: '',
        error: {
          type: 'VERIFY_PHONE',
          message: payload,
        },
      };

    // store user id and his information after success signup
    case types.SIGN_UP_REQUEST:
      return {
        ...state,
        error: {
          type: '',
          message: '',
        },
        onProgress: 'SIGNUP',
      };

    case types.SIGN_UP_SUCCESS:
      return {
        ...state,
        currentUser: payload,
        onProgress: '',
        completed: 'SIGNUP',
      };

    case types.SIGN_UP_FAIL:
      return {
        ...state,
        onProgress: '',
        error: {
          type: 'SIGNUP',
          message: error,
        },
      };

    // store status of user after verify phone
    case types.VERIFY_PHONE_REQUEST:
    case types.CHANGE_PHONE_NUMBER_VERIFY_PHONE_REQUEST:
      return {
        ...state,
        onProgress: 'VERIFY_PHONE',
        error: {
          type: '',
          message: '',
        },
      };

    case types.VERIFY_PHONE_SUCCESS:
    case types.CHANGE_PHONE_NUMBER_VERIFY_PHONE_SUCCESS:
      return {
        ...state,
        onProgress: '',
        completed: 'VERIFY_PHONE',
      };

    case types.VERIFY_PHONE_FAIL:
    case types.CHANGE_PHONE_NUMBER_VERIFY_PHONE_FAIL:
      return {
        ...state,
        onProgress: '',
        error: {
          type: 'VERIFY_PHONE',
          message: error ?? 'حدث خطأ .. يرجى التأكد من رمز التحقق',
        },
      };

    // store current user data
    case types.GET_CURRENT_USER_REQUEST:
      return {
        ...state,
        error: {},
        onProgress: 'GET_CURRENT_USER_DATA',
      };

    case types.GET_CURRENT_USER_SUCCESS:
      return {
        ...state,
        currentUser: payload,
        onProgress: '',
      };

    case types.GET_CURRENT_USER_FAIL:
      return {
        ...state,
        onProgress: '',
        error: {
          type: 'GET_CURRENT_USER_DATA',
          message: error,
        },
      };

    // store tutor profile  data
    case types.GET_TUTOR_PROFILE_REQUEST:
      return {
        ...state,
        tutorProfile: {},
        error: {},
        onProgress: 'GET_TUTOR_PROFILE_DATA',
      };

    case types.GET_TUTOR_PROFILE_SUCCESS:
      return {
        ...state,
        tutorProfile: payload,
        onProgress: '',
      };

    case types.GET_TUTOR_PROFILE_FAIL:
      return {
        ...state,
        onProgress: '',
        error: {
          type: 'GET_TUTOR_PROFILE_DATA',
          message: error,
        },
      };

    // login handling
    case types.SIGN_IN_REQUEST:
      return {
        ...state,
        error: {},
        onProgress: 'SIGN_IN',
      };

    case types.SIGN_IN_SUCCESS:
      return {
        ...state,
        currentUser: payload,
        isVerified: payload.status,
        isNew: payload.is_new === 'Yes',
        onProgress: '',
        completed: 'SIGN_IN',
      };

    case types.SIGN_IN_FAIL:
      return {
        ...state,
        onProgress: '',
        error: {
          type: 'SIGN_IN',
          message: error,
        },
      };

    // login handling
    case types.PROFILE_UPDATE_REQUEST:
      return {
        ...state,
        onProgress: 'PROFILE_UPDATE',
      };

    case types.PROFILE_UPDATE_SUCCESS:
      return {
        ...state,
        onProgress: '',
        completed: 'PROFILE_UPDATE',
      };

    case types.PROFILE_UPDATE_FAIL:
      return {
        ...state,
        onProgress: '',
        error: {
          type: 'PROFILE_UPDATE',
          message: error,
        },
      };

    // login handling
    case types.SEND_LOGIN_CODE_REQUEST:
    case types.CHANGE_PHONE_NUMBER_SEND_VERIFICATION_CODE_REQUEST:
      return {
        ...state,
        onProgress: 'SEND_CODE',
      };

    case types.SEND_LOGIN_CODE_SUCCESS:
    case types.CHANGE_PHONE_NUMBER_SEND_VERIFICATION_CODE_SUCCESS:
      return {
        ...state,
        status: payload.status,
        isNew: payload.is_new === 'Yes',
        onProgress: '',
        completed: 'SEND_CODE',
        currentUser: payload,
      };

    case types.SEND_LOGIN_CODE_FAIL:
    case types.CHANGE_PHONE_NUMBER_SEND_VERIFICATION_CODE_FAIL:
      return {
        ...state,
        onProgress: '',
        error: {
          type: 'SEND_CODE',
          message: error,
        },
      };

    case types.RESET_PHONE:
      return {
        currentUser: {},
        isVerified: '',
        isNew: '',
        onProgress: '',
        completed: '',
        error: {},
      };
    // resend phone code handling
    case types.RESEND_PHONE_REQUEST:
    case types.CHANGE_PHONE_NUMBER_RESEND_PHONE_REQUEST:
      return {
        ...state,
        error: {
          type: '',
          message: '',
        },
        onProgress: 'RESEND_PHONE',
      };

    case types.RESEND_PHONE_SUCCESS:
    case types.CHANGE_PHONE_NUMBER_RESEND_PHONE_SUCCESS:
      return {
        ...state,
        onProgress: '',
      };

    case types.RESEND_PHONE_FAIL:
    case types.CHANGE_PHONE_NUMBER_RESEND_PHONE_FAIL:
      return {
        ...state,
        onProgress: '',
        error: {
          type: 'RESEND_PHONE',
          message: error,
        },
      };

    // resend phone code handling
    case types.UPDATE_CURRENT_USER_REQUEST:
      return {
        ...state,
        onProgress: 'UPDATE_USER',
      };

    case types.UPDATE_CURRENT_USER_SUCCESS:
      return {
        ...state,
        onProgress: '',
        currentUser: payload,
        completed: 'UPDATE_USER',
      };

    case types.UPDATE_CURRENT_USER_FAIL:
      return {
        ...state,
        onProgress: '',
        error: {
          type: 'UPDATE_USER',
          message: error,
        },
      };

    case types.CLEAR_ERROR:
      return {
        ...state,
        error: INITIAL_STATE.error,
        onProgress: INITIAL_STATE.onProgress,
        completed: INITIAL_STATE.completed,
      };

    case types.RESET_TUTOR_PROFILE:
      return {
        ...state,
        error: INITIAL_STATE.error,
        tutorProfile: {},
        onProgress: INITIAL_STATE.onProgress,
        completed: INITIAL_STATE.completed,
      };

    case types.SET_PREV_PATH:
      return {
        ...state,
        prevPath: payload,
      };

    default:
      return { ...state };
  }
};

export default authReducer;
